<form [formGroup]="formGroup">
  <div class="card-data" formArrayName="target">
    <h4>
      {{ "Resume Target" | translate }}
    </h4>

    <div class="row align-items-center mb-3" *ngFor="let target of targets.controls; let i = index" [formGroupName]="i">

      <!-- Position Name -->
      <div class="col-12 col-md mx-2  p-0 p-md-auto">
        <label>{{ "Position" | translate }}</label>
        <input type="text" formControlName="name" placeholder="{{ 'Position Name' | translate }}" />
      </div>

      <!-- Description -->
      <div class="col-12 col-md  mx-2 mx-md-0  p-0 p-md-auto">
        <label>{{ "Description" | translate }}</label>
        <input type="text" formControlName="description" placeholder="{{ 'Description' | translate }}" />
      </div>

      <!-- Delete Button -->
      <div class="col-auto">
        <i class="bi bi-trash3 delete-icon mt-5" *ngIf="targets.length > 1" (click)="removeTarget(i)">
        </i>
      </div>
    </div>

    <!-- Add New Button -->
    <button type="button" class="border-button" (click)="addTarget()">
      {{ "Add New" | translate }}
      <i class="bi bi-plus-lg"></i>
    </button>
  </div>

  <!-- Next Button -->
  <div class="next-container px-4">
    <button type="button" class="gradient-button m-3" (click)="onNext()">
      {{ "Next" | translate }}
    </button>
  </div>
</form>